/** Confirm restoring email eligibility and NMLS-based LO Preview access. */
import { useRef } from 'react';
import { LoDialogDescription, LoDialogShell, LoDialogTitle } from './LoRadixOverlay';
import type { LoProspect } from '@/types/lo-prospect';

export function RestoreInviteAccessDialog({
  prospect,
  busy,
  onClose,
  onSubmit
}: {
  prospect: LoProspect;
  busy?: boolean;
  onClose: () => void;
  onSubmit: () => void | Promise<void>;
}) {
  const submittingRef = useRef(false);

  const submit = async () => {
    if (submittingRef.current) {
      return;
    }
    submittingRef.current = true;
    try {
      await onSubmit();
    } catch {
      // The parent owns the error toast and keeps this dialog open for retry.
    } finally {
      submittingRef.current = false;
    }
  };

  return (
    <LoDialogShell onClose={onClose}>
          <div className="modal-head">
            <div className="modal-eyebrow">Restore invite access</div>
            <LoDialogTitle>
              Restore access for {prospect.firstName} {prospect.lastName}?
            </LoDialogTitle>
            <LoDialogDescription>
              This clears their LO Preview email opt-out and restores eligible NMLS access. It does not
              send an email, and previously emailed private links stay invalid.
            </LoDialogDescription>
          </div>
          <div className="modal-foot">
            <button className="btn-sm" onClick={onClose} type="button">
              Cancel
            </button>
            <button className="btn-sm solid" onClick={() => void submit()} disabled={busy} type="button">
              {busy ? 'Restoring…' : 'Restore access'}
            </button>
          </div>
    </LoDialogShell>
  );
}
